import EmptyResult from 'components/others/EmptyResult';
import ReportUsersSummaryTableRow from './ReportUsersSummaryTableRow';
import type { UserIncomeReportRowType } from '@econtractor/types';

interface ReportUsersSummaryTableBodyProps {
    users: UserIncomeReportRowType[];
}

const ReportUsersSummaryTableBody = ({ users }: ReportUsersSummaryTableBodyProps) => (
    <tbody>
        {users.map((user) => (
            <ReportUsersSummaryTableRow key={user.userId} user={user} />
        ))}
        {!users.length ? (
            <tr>
                <td colSpan={2}>
                    <EmptyResult />
                </td>
            </tr>
        ) : null}
    </tbody>
);

export default ReportUsersSummaryTableBody;
